import { Phone, User } from "lucide-react";
import { useSelector } from "react-redux";
import { selectCustomerInfo } from "src/stores/calllogs";
export const CallerInfo = ({ callerInfo }) => {
  const customerInfo = useSelector(selectCustomerInfo);
  const name = customerInfo?.data?.result?.customer?.fullname ?? "New Customer";

  console.log(customerInfo, "customerInfo");

  return (
    <div className=" rounded-xl p-4 space-y-3  border-2">
      <div className="flex justify-between items-center">
        <div>
          <h4 className="font-medium text-gray-900 text-[18px] mb-3">
            Caller Information
          </h4>
          <div className=" flex items-center ">
            <div className="flex items-center  gap-1 border-r-2 pr-2">
              <Phone className="w-4 h-4 text-gray-400" />
              <span className="text-gray-900">{callerInfo?.caller}</span>
            </div>

            <div className="flex items-center gap-1 pl-2">
              <User className="w-4 h-4 text-gray-400" />
              <span className="text-gray-900">
                {/* {caller_name ?? "New Customer"} */}
                {name}
              </span>
            </div>
          </div>
        </div>
        {callerInfo?.code === "Setup" && (
          <p className="inline-flex items-center justify-center bg-[#ECECF0] text-gray-500 text-sm font-medium px-3 py-1 h-7 rounded-full leading-none">
            Ringing
          </p>
        )}
      </div>
    </div>
  );
};
